import { FC, useContext, useEffect, useState } from "react";
import { Modal, FormControl, Button } from "react-bootstrap";
import moment from "moment";
import userApi from "../../../api/userApi";
import { AppContext } from "../../../context";
import { User } from "../../../types/User";

interface Props {
  user: User;
  visible: boolean;
  onVisibleChange: (val: boolean) => void;
}

const RecomputeDaysModal: FC<Props> = ({ user, visible, onVisibleChange }) => {
  const { showToast } = useContext(AppContext);
  const [dates, setDates] = useState<string[]>([]);

  useEffect(() => {
    if (!visible) {
      setDates([]);
    }
  }, [visible]);

  return (
    <Modal show={visible} onHide={() => onVisibleChange(false)}>
      <Modal.Header closeButton={true}>
        <Modal.Title className="flex-grow-1">{user.firstName} Recompute overtime</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <FormControl
          type="date"
          onChange={(e) => {
            if (moment(e.target.value, "YYYY-MM-DD").isValid()) {
              setDates([...dates, e.target.value]);
            }
          }}
        />
        <div className="mt-3 d-flex flex-wrap">
          {dates.map((d) => {
            return (
              <div
                className="border rounded clickable px-2 py-1 me-2"
                key={d}
                onClick={() => {
                  setDates(dates.filter((dd) => dd !== d));
                }}>
                {d}
              </div>
            );
          })}
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button
          onClick={async () => {
            try {
              await userApi.recomputeDays(user.id, dates);
              onVisibleChange(false);
              showToast({
                title: "Success",
                message: "Balances recalculated",
                variant: "success",
              });
            } catch (e) {
              showToast({
                message: e.message || "Unkown error",
                title: "Recomp failed",
                variant: "danger",
              });
            }
          }}>
          Recompute
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default RecomputeDaysModal;
